import { create } from 'zustand';
import { tokenStorage } from '@/services/api/client';
import type { AuthResult, AuthUser } from '@/types/api';

/**
 * Zustand yalnızca OTURUM KİMLİĞİNİ tutar (kim giriş yaptı, token var mı).
 * Kullanıcıya ait sunucu verisi (siparişler, adresler) TanStack Query'de kalır;
 * buraya kopyalanmaz.
 */
interface AuthState {
  user: AuthUser | null;
  /** Uygulama açılışında /auth/me denemesi bitti mi? */
  isResolved: boolean;
  isAuthenticated: boolean;
  isAdmin: boolean;

  setSession: (result: AuthResult) => void;
  setUser: (user: AuthUser | null) => void;
  markResolved: () => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isResolved: false,
  isAuthenticated: false,
  isAdmin: false,

  setSession: (result) => {
    tokenStorage.set(result.accessToken, result.refreshToken);
    set({
      user: result.user,
      isAuthenticated: true,
      isAdmin: result.user.role === 'ADMIN',
      isResolved: true,
    });
  },

  setUser: (user) =>
    set({
      user,
      isAuthenticated: user !== null,
      isAdmin: user?.role === 'ADMIN',
    }),

  markResolved: () => set({ isResolved: true }),

  clear: () => {
    tokenStorage.clear();
    set({ user: null, isAuthenticated: false, isAdmin: false, isResolved: true });
  },
}));
